import { createContext, Dispatch, SetStateAction } from 'react'

export type OAuthPasswordReturn = {
  interactionId: string
  email: string
  expiresAt: number
}

export type PasswordRequestContextStore = {
  oauthReturn: [
    OAuthPasswordReturn | undefined,
    Dispatch<SetStateAction<OAuthPasswordReturn | undefined>>
  ]
  email: [string | undefined, Dispatch<SetStateAction<string | undefined>>]
  password: [string | undefined, Dispatch<SetStateAction<string | undefined>>]
  errorRequestPassword: [string | undefined, Dispatch<SetStateAction<string | undefined>>]
}

const PasswordRequestContext = createContext<PasswordRequestContextStore | undefined>(undefined)

export default PasswordRequestContext
